import classes from './About.module.css'
import React from 'react'
// import { Link } from 'react-router-dom'
// import GoButton from '../components/GoButton'
import Header from '../components/Header'
import Settings from '../settings/Settings'

const About = props => {
    return (
        <>
            {props.showSettings && <Settings onClose={props.onClose} sound={props.sound} soundOnOff={props.soundOnOff} />}
            <Header title="About" onClose={props.onClose}/>
            <div className={classes.about}>
                <div className={classes.text}>
                    <p>Hi! My name is Max and I love English language! That's why I made this app. And it's an ineresting one! It uses several leayers of randomness in order to generate a question. Another cool feature, it has an algorithm implemented which prevents users clicking until the sound is ended. You can find the code on my GitHub page</p>
                    {/* <p>Thanks:</p>
                    <p>I'd like to thank Mickie Inglish, the author of the book "Английский для вас и вашей бабушки", who has kindly helped me to choose such a good title for the app. Thanks, buddy)</p>
                    <p>I would also like to thank all of my teammates from my Speaking Club, for reviewng the app and all the advices thay gave me) Thank you guys)</p> */}
                </div>
            </div>

        </>
    )
}

export default About